import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flexWrap" }
const _hoisted_2 = { class: "flexWrap" }
const _hoisted_3 = { class: "flexWrap" }
const _hoisted_4 = {
  slot: "footer",
  class: "flexCenter"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("提 交")

import { requestAddUser,requestUserDetails } from '@/api/api'
	import { ref,onMounted } from 'vue'
	import { ElMessage } from 'element-plus'
	interface formType {
		uuid: string
		code: string
		user: string
		pwd: string
		name: string
		rolelist: string
		taskstartperm: string
	}
	
export default /*#__PURE__*/_defineComponent({
  name: 'AddUser',
  props: {
		uuid:{
			type: String,
			default: ""
		}
	},
  emits: ['cancel'],
  setup(__props, { emit }) {

const props = __props

    
	
	const form = ref<formType>({
		uuid:'',
		code:'',
		user:'',
		pwd:'',
		name:'',
		rolelist:'',
		taskstartperm: '1',
	})
	onMounted(()=>{
		if(props.uuid != ""){
			requestUserDetails({
				uuid:props.uuid
			}).then((res:any)=>{
				if(res.status === 1){
					form.value = res.datalist[0]
				}
			})
		}
	})
	
	const qx = () =>{
		emit("cancel")
	}
    const submit = () =>{
		if(form.value.user === "" || form.value.pwd === ""){
			ElMessage.error("用户名或密码不能为空");
			return
		}
        requestAddUser({
            uuid:form.value.uuid,
            code:form.value.code,
            user:form.value.user,
            pwd:form.value.pwd,
            name:form.value.name,
            rolelist:form.value.rolelist,
            taskstartperm:form.value.taskstartperm
        }).then((res:any)=>{
            if(res.status === 1){
                ElMessage({
                    message: res.msg,
                    type: 'success',
                    duration: 500
                });
				setTimeout(()=>{
					emit("cancel",1)
				},500)
            }
        })
    }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      "label-width": "80px",
      style: {"background-color":"#fff","padding":"30px 20px"},
      "show-message": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_form_item, { label: "编号" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.value.code,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.code) = $event)),
                placeholder: "请输入编号",
                style: {"width":"200px"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "用户名" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.value.user,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.user) = $event)),
                placeholder: "请输入用户名",
                style: {"width":"200px"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (form.value.uuid == '')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "密码"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.pwd,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.pwd) = $event)),
                    placeholder: "请输入密码",
                    style: {"width":"200px"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form_item, { label: "姓名" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.value.name,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.name) = $event)),
                placeholder: "请输入姓名",
                style: {"width":"200px"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "角色" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: form.value.rolelist,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.rolelist) = $event)),
                placeholder: "请选择角色",
                style: {"width":"200px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "管理员",
                    value: "管理员"
                  }),
                  _createVNode(_component_el_option, {
                    label: "成员",
                    value: "成员"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_form_item, { label: "任务启动" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: form.value.taskstartperm,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.taskstartperm) = $event)),
                placeholder: "请选择",
                style: {"width":"200px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "有权限",
                    value: "1"
                  }),
                  _createVNode(_component_el_option, {
                    label: "无权限",
                    value: "0"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_button, {
        onClick: _cache[6] || (_cache[6] = ($event: any) => (qx())),
        round: ""
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        style: {"color":"#fff"},
        type: "primary",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (submit())),
        round: ""
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})